/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_About_GithubInputs */

const en_ui_settings_about_github = /** @type {(inputs: Ui_Settings_About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub Repository`)
};

const de_ui_settings_about_github = /** @type {(inputs: Ui_Settings_About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub-Repository`)
};

/**
* | output |
* | --- |
* | "GitHub Repository" |
*
* @param {Ui_Settings_About_GithubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_about_github = /** @type {((inputs?: Ui_Settings_About_GithubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_About_GithubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_about_github(inputs)
	return de_ui_settings_about_github(inputs)
});